<template>
    <div class="counter">
        <button class="counter__button" @click="decreaseCounter">-</button>
        <input type="text" class="counter__input" v-model="counter" @input="handleInput" />
        <button class="counter__button" @click="increaseCounter">+</button>
    </div>
</template>

<script>
export default {
    name: "CounterApp",
    props: {
        modelValue: {
            type: Number,
            default: 1,
        },
        countProducts: {
            type: Number,
            default: 0,
        },
        productId: {
            type: Number,
            default: null,
        },
        productIdLimited: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            counter: this.modelValue,
        };
    },
    watch: {
        counter(newValue) {
            this.$emit("update:modelValue", newValue);
        },
    },
    methods: {
        increaseCounter() {
            if (this.productIdLimited == this.productId && this.counter >= this.countProducts) return;
            this.counter++;
        },
        decreaseCounter() {
            if (this.counter > 1) {
                this.counter--;
            }
        },
        handleInput() {
            this.counter = this.counter.replace(/\D/g, "");
            if (this.productIdLimited == this.productId && this.counter >= this.countProducts) {
                this.counter = 1;
            }
        },
    },
};
</script>

<style></style>
